export const getSearchTerms = ({ searchDetailsReducer: { search_terms } }) => search_terms;
export const getAppliedFilter = ({ searchDetailsReducer: { appliedFilters } }) => appliedFilters;
export const getResultSections = ({ searchDetailsReducer: { result_sections } }) => result_sections;
export const getIsChangeFilters = ({ searchDetailsReducer: { isChangeFilters } }) =>
	isChangeFilters;
